import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  Type,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import { HttpClient } from "@angular/common/http";
import {MatSnackBar as MatSnackBar } from "@angular/material/snack-bar";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { Global } from "src/app/services/global";
import { AuthService } from "src/app/services/auth.service";
import { ModuleService } from "src/app/services/module.service";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: "app-components-prewiew",
  templateUrl: "./components-prewiew.component.html",
  styleUrls: ["./components-prewiew.component.css"],
})
export class ComponentsPrewiewComponent implements OnInit {
  component: any = { setting: {} };
  id: any;
  settingsJson: string;
  @ViewChild("content2", { read: ViewContainerRef,static:false})
    @Output() result = new EventEmitter<any>();
    @Output() closeChildSettingsEmitter = new EventEmitter();
    content2!: ViewContainerRef;
  childData;
  componetName: string;
  CSS: string;
  JS: string;
  settings: any;
  OrgComponent: any;
  showPreview: boolean;
  siteCultures: any = [];
  currentCulture: any = "";
  culturesSettings: any = {};
  global: Global;
  selectedLanguageType: string;
  options: any = {
    indent_size: 4,
    indent_char: " ",
    eol: "\n",
    indent_level: 0,
    max_preserve_newlines: 10,
    wrap_line_length: 0,
    operator_position: "before-newline",
    brace_style: "collapse",
    indent_scripts: "normal",
    indent_with_tabs: true,
    preserve_newlines: true,
    end_with_newline: false,
    editorconfig: false,
    space_in_paren: false,
    space_in_empty_paren: false,
    jslint_happy: false,
    space_after_anon_function: false,
    space_after_named_function: false,
    unindent_chained_methods: false,
    break_chained_methods: false,
    keep_array_indentation: true,
    unescape_strings: false,
    e4x: false,
    comma_first: false,
    eval_code: false,
    space_before_conditional: true,
    "indent-inner-html": false,
  };
  codeChanged: boolean;
  isSettings: boolean = true;
  modalRef: BsModalRef | null;
  pageJson: any;
  constructor(
    global: Global,
    private authService: AuthService,
    private _snackBar: MatSnackBar,
    private snotifyService: ToastrService,
    private routing: Router,
    private httpClient: HttpClient,
    private activeRouter: ActivatedRoute,
    private moduleService: ModuleService,
    private bmodalService: BsModalService,
        private cdr: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {
    // this.global = global;
    // 
  }

  ngOnInit() {
    this.id = this.activeRouter.snapshot.paramMap.get("id");

    this.httpClient
      .get("/Components/GetComponentByID/" + this.id)
      .subscribe((res: any) => {
        this.component = res;

        this.component.componentName = res.dataKey;

        this.component.setting = res.settings ? JSON.parse(res.settings) : {};

        this.JS = this.component.setting.js =
          this.component.setting.js || this.component.setting.JS;
        this.CSS = this.component.setting.css =
          this.component.setting.css || this.component.setting.CSS;

        this.OrgComponent = JSON.parse(JSON.stringify(this.component));
        this.component.setting = this.settings = this.component.setting
          ? this.component.setting
          : {};
        this.componetName =
          res.dataKey.replace("Component", "") + "SettingsComponent";

        this.siteCultures = this.authService.siteCultures;

        this.siteCultures.unshift("default");
        this.currentCulture = this.siteCultures[0];
        this.setCultureSettings();
        this.loadSettingComp();
      });
  }

  beautify(type) {
    if (type == "css") {
      this.options["indent_size"] = 1;
      this.component.setting.css = this.global.beautify[type](
        this.component.setting.css,
        this.options
      );
    } else {
      this.options["indent_size"] = 4;
      this.component.setting.js = this.global.beautify[type](
        this.component.setting.js,
        this.options
      );
    }
  }

  setCultureSettings() {
    for (let index = 0; index < this.siteCultures.length; index++) {
      const e = this.siteCultures[index];
      var setting = this.component.setting[e]
        ? JSON.parse(JSON.stringify(this.component.setting[e]))
        : this.component.setting["default"]
        ? JSON.parse(JSON.stringify(this.component.setting["default"]))
        : JSON.parse(JSON.stringify(this.component.setting));
      this.culturesSettings[e] = setting;
    }
    this.component.setting = this.culturesSettings[this.currentCulture];
  }

  // loadSettingComp() {
  //   this.content2.clear();
  //   var x = this.moduleService.ComponentFactory[this.componetName];
  //   if (this.moduleService.ComponentFactory[this.componetName]) {
  //     //create setting component
  //     const component: any = this.content2.createComponent(x, 0);

  //     //sending @Input() values
  //     component.instance.data = {
  //       page: {},
  //       component: this.component,
  //       ComponentFactory: this.moduleService.ComponentFactory,
  //       dayGridPlugin: dayGridPlugin,
  //       interactionPlugin: interactionPlugin,
  //     };
  //     //save setting for each component
  //     component.instance.setting.subscribe((res) => {
  //       if (res != 0) {
  //         this.httpClient
  //           .post("/Components/SaveComponentSettings", {
  //             id: Number(this.id),
  //             settings: JSON.stringify(this.culturesSettings),
  //           })
  //           .subscribe((res: any) => {
  //             this.openNotifySuccess("Default Settings Saved successfuly");
  //           });
  //       } else {
  //         this.routing.navigate(["Components"]);
  //       }
  //     });
  //   } else {
  //     console.log("No Component Found =>" + this.componetName);
  //   }
  // }

  async loadSettingComp() {
    this.content2?.clear();



    // Create component
    const componentRef = this.moduleService.ComponentFactory[this.componetName];
    if (componentRef) {
    const componentFactory = this.componentFactoryResolver
    .resolveComponentFactory(componentRef);
 
    // const componentRef = this.content2.createComponent(componentFactory);

   
      //create setting component
      const component: any = this.content2.createComponent(componentFactory);;
      //sending @Input() values
      this.component.componentSettingsId =
        this.component.componentSettingsId ||
        Math.random().toString(36).substr(2, 9) + new Date().getTime();

      component.instance.data = {
        page: {},
        component: this.component, 
        moduleService: this.moduleService,
        authService: this.authService,
        ComponentFactory: this.moduleService.ComponentFactory,
        enviroment: "",
        dayGridPlugin: dayGridPlugin,
        interactionPlugin: interactionPlugin,
      };

      //save setting for each component
      component.instance.setting.subscribe((res) => {
    
        if (res != 0) {
          if (
            this.component.sharedSettings &&
            this.component.categoryId == 71 &&
            this.component.sharedStatus !== 1
          ) {
            this.component.setting = JSON.parse(
              JSON.stringify(this.culturesSettings)
            );
            this.component.setting.js = this.JS;
            this.component.setting.css = this.CSS;

            // if (!this.component.sharedSettings) {
            //   this.httpClient
            //     .post("/Components/SaveComponentSettings/", {
            //       id: this.component.id,
            //       settings: JSON.stringify(this.culturesSettings),
            //     })
            //     .subscribe((res: any) => {
            //       this.result.emit({ result: "done", data: this.component });
            //     });
            // } else {
            var data = {
              id: this.component.id,
              settings: JSON.stringify(this.component.setting),
              cultureId: this.currentCulture ? this.currentCulture : null,
            };

            if (this.component.id !== 0 && this.component.sharedSettings) {
              this.httpClient
                .post("/Elements/UpdateSharedElementSettings/", data)
                .subscribe((res: any) => {
                  this.result.emit({
                    result: "updateShared",
                    data: this.component,
                  });
                });
            }
          } else {
            res.JS = this.JS;
            res.CSS = this.CSS;
            this.save();
          }
        } else this.close();
      });

      if (component.instance.viewChildSetting)
        component.instance.viewChildSetting.subscribe((res) => {
          if (res) {
            let val = JSON.parse(JSON.stringify(res));
            if (
              this.childData &&
              this.childData.componentSettingsId &&
              this.childData.componentSettingsId != val.componentSettingsId
            ) {
              this.childData = null;
              setTimeout(() => {
                this.childData = JSON.parse(JSON.stringify(val));
              }, 100);
            } else this.childData = JSON.parse(JSON.stringify(val));
            this.cdr.detectChanges();
          }
        });
      if (component.instance.myChilds) {
        component.instance.myChilds.subscribe((res) => {
          if (res) {
            let val = JSON.parse(JSON.stringify(res));
            this.component.setting.childsData = val;
          }
        });
      }
    } else console.log("No Component Found =>" + this.componetName);
  }
  changeCulture() {
    this.component.setting = this.culturesSettings[this.currentCulture];
    this.loadSettingComp();
  }
  save() {
    this.component.setting = JSON.parse(JSON.stringify(this.culturesSettings));
    // this.component.currentCulture = this.currentCulture;
    this.result.emit({
      result: "done",
      data: this.component,
      data1: {},
    });
    this.closeChildSettingsEmitter.emit(true);
  }
  resetSetting() {
    this.component.setting = this.culturesSettings = {};
    this.setCultureSettings();

    this.loadSettingComp();
  }
  close() {
    this.result.emit({ result: "canceled", data: this.OrgComponent });
  }

  openCode(template) {
    this.settingsJson = JSON.stringify(
      this.culturesSettings[this.currentCulture],
      undefined,
      4
    );
    this.modalRef = this.bmodalService.show(template, { class: " modal-xl" });
  }

  savePageJson() {
    this.culturesSettings[this.currentCulture] = JSON.parse(this.settingsJson);
    this.modalRef.hide();
  }

  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2500,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  checkTab($event) {
    this.showPreview = false;
    if ($event.index == 1) {
      this.showPreview = true;
    }
  }
}
